var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.linkify)?_c('p',{class:_vm.classes},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2):_c('p',{directives:[{name:"linkified",rawName:"v-linkified"}],class:_vm.classes,domProps:{"innerHTML":_vm._s(_vm.text)}})}
var staticRenderFns = []

export { render, staticRenderFns }